'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './navBar';
import SideMenu from './sideMenu';
import LeaveHeader from './leaveComponents/leaveHeader';
import LeaveBody from './leaveComponents/leaveBody';
import leaveAction from '../actions/leaveAction';
import leaveStore from '../stores/leaveStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import menuAction from '../actions/menuAction';
import LeaveCal from './leaveComponents/leaveCal';
import Loading from './loading';
import userStore from '../stores/userStore';

class LeaveApp extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            processingFilter: filterStore.getState().processing,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            iniLoadTeamMember: filterStore.getState().iniLoadTeamMember,
            teamMember: filterStore.getState().teamMember,
            iniLoadHoliday: filterStore.getState().iniLoadHoliday,
            holiday: filterStore.getState().holiday,
            staffId: userStore.getState().staffId,
            processing: leaveStore.getState().processing,
            leaves: leaveStore.getState().leaves,

            startYear: leaveStore.getState().startYear,
            startMonth: leaveStore.getState().startMonth,
            displayMode: 0,
        };
    }
    componentWillMount() {

    }
    componentDidMount() {
        leaveStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        userStore.listen(this.onUserChange);
        menuAction.pageNumber(5);


        if (!this.state.processingFilter && !this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }
        if (!this.state.iniLoadTeamMember) {
            filterAction.getTeamMember();
        }
        if (!this.state.iniLoadHoliday) {
            filterAction.processing(true);
            filterAction.getHoliday();
        }
    }
    componentWillUnmount() {
        leaveStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state) {
        this.setState({
            staffId: state.staffId
        })
    }
    onFilterChange(state) {
        this.setState({
            staffs: state.staffs,
            processingFilter: state.processing,
            iniLoadStaff: state.iniLoadStaff,
            iniLoadTeamMember: state.iniLoadTeamMember,
            teamMember: state.teamMember,
            iniLoadHoliday: state.iniLoadHoliday,
            holiday: state.holiday,
        });
    }
    onChange(state) {
        this.setState({
            leaves: state.leaves,
            processing: state.processing,
            startYear: state.startYear,
            startMonth: state.startMonth,
        });
    }

    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        this.setState({ displayMode: index });
    }
    render() {
        let bodyDisplay = '';
        let isOutsider = this.state.staffId && this.state.staffId.includes("TG0");
        let leaves = JSON.parse(JSON.stringify(this.state.leaves));
        if(isOutsider){
            leaves = leaves.filter((lv)=>{
                return lv.staffId && lv.staffId.includes("TG0");
            })
        }
        if (this.state.displayMode == 0) {
            bodyDisplay = (
                <LeaveBody leaves={leaves} processing={this.state.processing} {...this.props} />
            );
        } else {
            bodyDisplay = (
                <LeaveCal leaves={leaves} startYear={this.state.startYear} startMonth={this.state.startMonth}
                    holiday={isOutsider ? { holiday: [], event: [], saturdayWork: this.state.holiday.saturdayWork } : this.state.holiday} />
            )
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <SideMenu {...this.props} />
                    <NavBar {...this.props} />
                    <div className=" col-md-10  col-sm-8 atd">
                        <LeaveHeader iniLoad={this.state.iniLoad} staffs={this.state.staffs} leaves={this.state.leaves}
                            teamMember={this.state.teamMember} />
                        <div className="divider"></div>
                        <div className="atd-i-dp">
                            <div className="atd-dis">Mode: </div>
                            <div className="btn-group" role="group">
                                <button className={"btn btn-default " + (this.state.displayMode == 0 ? "active" : "")} data-index="0" onClick={this.handleClick}>
                                    <span className="glyphicon glyphicon-th-list"></span>
                                </button>
                                <button className={"btn btn-default " + (this.state.displayMode == 1 ? "active" : "")} data-index="1" onClick={this.handleClick}>
                                    <span className="glyphicon glyphicon-th"></span>
                                </button>
                            </div>
                        </div>
                        {bodyDisplay}
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default LeaveApp;


// WEBPACK FOOTER //
// ./app/components/leaveApp.js